<header class="baer-header">
  <div class="breadcrumb"><a routerLink="/assessments">BAER Assessments</a> &gt; {{assessment?.baer_name}}</div>
  <h1 id="table" class="site-page-title"><span class="large-font">{{assessment?.baer_name}}</span></h1>
  @if (assessment) {
    <div class="status-div">
      Assessment Status:
      <mat-chip [ngClass]="'chip-'+assessment.assessment_status_id">
        {{assessment.assessment_status_id | statusBadge}}
      </mat-chip>
    </div>
  }
</header>
@if (user) {
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms" [(selectedIndex)]="tabIndex">
    <mat-tab aria-hidden="false">
      <ng-template mat-tab-label>
        <fa-icon [icon]="faFileLines" style="font-size: 20px;" aria-label="2500-8 Reports"></fa-icon>&nbsp;
        2500-8 Reports
      </ng-template>
      <ng-template matTabContent>
        @if (user && assessment && reports !== undefined) {
          <app-reports-tab
            [fire]="assessment"
            [reports]="reports"
            [updateFireSubject]="updateFireSubject"
            [isEditable]="isEditable"
            [user]="user"
          ></app-reports-tab>
        }
      </ng-template>
    </mat-tab>
    <mat-tab aria-hidden="false">
      <ng-template mat-tab-label>
        <fa-icon [icon]="faUsers" style="font-size: 20px;" aria-label="All Users"></fa-icon>&nbsp;
        Teams
      </ng-template>
      <ng-template matTabContent>
        @if (reports && user && assessment) {
          <app-teams-tab
            [(reports)]="reports"
            [assessment]="assessment"
            [isEditable]="isEditable"
            [user]="user"
            [report_num]="report_num()"
          ></app-teams-tab>
        }
      </ng-template>
    </mat-tab>
    <mat-tab aria-hidden="false">
      <ng-template mat-tab-label>
        <fa-icon [icon]="faFileCircleCheck" style="font-size: 20px;" aria-label="Funding"></fa-icon>&nbsp;
        Accomplishments
      </ng-template>
      <ng-template matTabContent>
        @if (reports && assessment) {
          <app-accomplishments
            [reports]="reports"
            [assessment]="assessment"
          ></app-accomplishments>
        }
      </ng-template>
    </mat-tab>
    <mat-tab aria-hidden="false">
      <ng-template mat-tab-label>
        <fa-icon [icon]="faFileInvoiceDollar" style="font-size: 20px;" aria-label="Funding"></fa-icon>&nbsp;
        Funding
      </ng-template>
      <ng-template matTabContent>
        <app-funding-tab
          [reports]="reports"
          [assessment]="assessment"
        ></app-funding-tab>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
}